import React, { useEffect } from 'react'
import className from 'classnames/bind'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router'

import style from './MyhouseMainResidentPage.module.scss'

import MyhouseMainResidentList from '@Components/modules/MyhouseMainResidentList'
import SvgMyhouseMainResidentMore from '@Ui/images/myhouse/myhouse_main_resident--more.svg'
import useMain from '@Hooks/myhouse/main/useMain'
import useBoard from '@Hooks/myhouse/board/useBoard'
import useModal from '@Hooks/myhouse/useModal'
import useReview from '@Hooks/myhouse/review/useReview'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import SvgMyhouseMainResidentEmpty from '@Ui/images/myhouse/myhouse_main_resident--empty.svg'
import { FETCH_STATUS } from '@Root/contants'
import { MY_HOUSE_AUTH_STATUS } from '@Root/contants/myhouse'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

const MyhouseMainResidentPage: React.FC = () => {
  //변수선언부
  const { reduxMain, refreshMasonryGrid } = useMain()
  const { house } = reduxMain
  const complexNo = house?.complexNo || 0
  const { loadInitialReviewList, review } = useReview()
  const { list, totalCount, listFetchStatus } = review
  const { getAuthStatusForBoard } = useBoard()
  const { open } = useModal()
  const history = useHistory()

  const reviewIsEmpty = isEmpty(list)

  useEffect(() => {
    if (complexNo) {
      loadInitialReviewList({
        complexNo,
        offset: 0,
        limit: 4,
      })
    }
  }, [complexNo])

  useEffect(() => {
    if (listFetchStatus === FETCH_STATUS.SUCCESS) {
      refreshMasonryGrid()
    }
  }, [listFetchStatus])

  if (listFetchStatus === FETCH_STATUS.INITIAL || !complexNo) {
    return <></>
  }

  return (
    <>
      <div className={cx('article')}>
        {reviewIsEmpty ? (
          <>
            {/* UI 개발 요청 : 해당 구간이 정상적으로 나오도록 처리 부탁드리겠습니다. 처리 후 코멘트 제거 */}
            <div className={cx('header')}>
              <div className={cx('wrap_title')}>
                <h2 className={cx('title')}>입주민 리뷰</h2>
              </div>
            </div>

            <div className={cx('image_empty')}>
              <SvgMyhouseMainResidentEmpty />
            </div>
            <p className={cx('empty_text')}>
              등록된 리뷰가 없습니다. 
            </p>
          </>
        ) : (
          <>
            <div className={cx('header')}>
              <div className={cx('wrap_title')}>
                <h2 className={cx('title')}>입주민 리뷰</h2>
                <em className={cx('count')}>{totalCount}</em>
              </div>
            </div>
            <MyhouseMainResidentList list={list} complexNo={complexNo} />
            <a href={`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/${complexNo}/reviews`} className={cx('link_more')} onClick={handleNclickMix(NCLICK.MY_HOUSE.MAIN_REVIEW.MORE)}>
              <span className={cx('title')}>리뷰 더보기</span>
              <SvgMyhouseMainResidentMore />
            </a>
          </>
        )}
      </div>
    </>
  )
}

export default MyhouseMainResidentPage
